import { PropType, ExtractPropTypes } from 'vue'
import { Required } from 'utility-types'
import type { SelectProps } from 'ant-design-vue/es/select'
// type SelectorTypes = keyof Reference.SelectorTypes

export const invoiceContentSelectProps = {
  apiParams: {
    type: Object,
    default: () => ({}),
  }
}

export type InvoiceContentSelectProps = Partial<ExtractPropTypes<typeof invoiceContentSelectProps>> & SelectProps